import api from "../../Services/api";

export const fetchFormsSets = async () => {
  try {
    const response = await api.get("/forms/formset/all", {
      data: {},
    });
    return response.data.formSets;
  } catch (error) {
    console.error("Error fetching forms:", error);
    throw error;
  }
};

export const fetchUserFormsets = async () => {
  try {
    const response = await api.get("/forms/formset/superuser/", {
      data: {},
    });
    return response.data.formSets;
  } catch (error) {
    console.error("Error fetching user formsets:", error);
    throw error;
  }
};

export const createFormSet = async (formSetData) => {
  try {
    const response = await api.post("/forms/formset/create", formSetData);
    return response.data;
  } catch (error) {
    console.error("Error creating formset:", error);
    throw error;
  }
};

export const deleteFormSet = async (formsetId) => {
  try {
    const response = await api.delete(`/forms/formset/delete/${formsetId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting formset:", error);
    throw error;
  }
};

export const fetchForms = async () => {
  try {
    const response = await api.get("/forms/all", {
      data: {},
    });
    const activeForms = response.data.forms.filter(
      (form) => form.softDelete !== true
    );
    return activeForms;
  } catch (error) {
    console.error("Error fetching forms:", error);
    throw error;
  }
};

export const fetchUserCreatedForms = async () => {
  try {
    // Get user data from localStorage and ensure it exists
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    // Check if userData and id exist
    if (!userData || !userData.id) {
      console.error("User data not found in localStorage");
      return [];
    }

    // Convert userId to string explicitly to match backend expectations
    const userId = String(userData.id);

    // Fetch forms created by the current logged-in user
    const response = await api.get(`/forms/all/${userId}`);
    return response.data.forms || [];
  } catch (error) {
    console.error("Error fetching user forms:", error);
    // If 403 or 204, it's not a critical error, just return empty forms
    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 204)
    ) {
      return [];
    }
    throw error;
  }
};

export const updateFormSetMembers = async (formSetId, { add, remove }) => {
  try {
    const response = await api.post(`/forms/update-formset/${formSetId}`, {
      add: add || [],
      remove: remove || [],
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating formset ${formSetId}:`, error);
    throw error;
  }
};
